
import { useState, useEffect } from 'react';
import { Menu, X, Code, Laptop, Zap } from 'lucide-react';
import { cn } from '@/lib/utils';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const toggleMenu = () => setIsOpen(!isOpen);
  
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header 
      className={cn(
        "fixed top-0 left-0 right-0 z-50 transition-all duration-300 py-4 px-6 md:px-8",
        scrolled ? "bg-background/80 backdrop-blur-md shadow-md" : "bg-transparent"
      )}
    >
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <a href="#" className="flex items-center space-x-2 z-10">
          <Zap className="h-8 w-8 text-secondary animate-pulse-slow" />
          <span className="text-2xl font-display font-bold tech-gradient-text">BakerTech</span>
        </a>
        
        <nav className="hidden md:flex items-center space-x-8">
          <a href="#services" className="nav-link">Services</a>
          <a href="#about" className="nav-link">About</a>
          <a href="#contact" className="nav-link">Contact</a>
          <a href="#contact" className="btn-primary animate-fade-in">Get Started</a>
        </nav>
        
        <button 
          className="md:hidden z-10 text-foreground" 
          onClick={toggleMenu}
          aria-label={isOpen ? "Close menu" : "Open menu"}
        >
          {isOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
        
        {/* Mobile menu */}
        <div className={cn(
          "fixed inset-0 bg-background/95 backdrop-blur-md flex flex-col items-center justify-center space-y-8 transition-all duration-300 md:hidden",
          isOpen ? "opacity-100 translate-x-0" : "opacity-0 translate-x-full pointer-events-none"
        )}>
          <a href="#services" className="text-xl font-medium" onClick={toggleMenu}>Services</a>
          <a href="#about" className="text-xl font-medium" onClick={toggleMenu}>About</a>
          <a href="#contact" className="text-xl font-medium" onClick={toggleMenu}>Contact</a>
          <a href="#contact" className="btn-primary" onClick={toggleMenu}>Get Started</a>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
